// extracted by mini-css-extract-plugin
export default {"container":"style_container__msBNo","mainHeading":"style_mainHeading__QIQFf"};